import qs from 'qs';
import _ from 'lodash';

import request from '../../../../shared/lib/request';
import { API } from '../../../../shared/constants';

const getAll = () => request(
  {
    url: API.PROVENIENZA,
    method: 'GET',
    params: {
      pagination: false,
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const get = (id) => request(
  {
    url: `${API.PROVENIENZA}/${id}`,
    method: 'GET',
  });

const getOptions = (context) => getAll().then( // context should be "pratica" or "anagrafica"
    (res) => res._embedded.provenienza.map((obj) => ({ // eslint-disable-line
      value: obj.id,
      label: obj.nome,
      disabled: context === 'pratica' ? !obj.attivoPratica : !obj.attivoAnagrafica,
      parent: obj.parent,
      dettaglioProvenienzaObbligatoria: obj.dettaglioProvenienzaObbligatoria,
      provenienzaTecnocasaObbligatoria: obj.provenienzaTecnocasaObbligatoria,
      options:  _.get(obj, '_embedded.children', []).map( // eslint-disable-line
        (opt) => ({
          label: opt.nome,
          value: opt.nome,
          disabled: context === 'pratica' ? !opt.attivoPratica : !opt.attivoAnagrafica,
          attivoAnagrafica: opt.attivoAnagrafica,
          attivoPratica: opt.attivoPratica,
        })
      ),
    })
                                          )
  ).then((data) => ({ options: data.filter((obj) => obj.label && !obj.parent) })); // TODO: Verificare come mai lato server si aggiungono provenienze.

const getActiveOptions = () => request(
  {
    url: API.PROVENIENZA,
    method: 'GET',
    params: {
      filter: [{
        type: 'eq',
        field: 'attivo',
        value: 1,
      }],
    },
    paramsSerializer: (params) => qs.stringify(params),
  }
).then((res) => res._embedded.provenienza // eslint-disable-line
  .filter((obj) => obj.nome)
  .map((obj) => ({
    value: obj.id,
    label: obj.nome,
    disabled: !obj.attivo,
    dettaglioProvenienzaObbligatoria: obj.dettaglioProvenienzaObbligatoria,
    provenienzaTecnocasaObbligatoria: obj.provenienzaTecnocasaObbligatoria,
  })));

const ProvenienzaService = {
  getAll,
  get,
  getOptions,
  getActiveOptions,
};

export default ProvenienzaService;



// WEBPACK FOOTER //
// ./app/shared/services/api/provenienza/index.js